
<div class="bg-white dark:bg-[#040508]">
  <footer
  class="bg-black dark:bg-gray-900 text-white py-16 md:ml-5 md:mr-5 md:mb-5 md:rounded-[30px]"
>
  <div class="max-w-6xl mx-auto px-6 md:px-8">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
      <!-- Logo and Social Column -->
      <div class="col-span-2 md:col-span-1">
        <div class="w-12 h-12 rounded-lg flex items-center justify-center mb-6">
          <img [src]="'/assets/svgs/footer-icon.svg'" alt="Design Jobs Careers" />
        </div>

        <h3 class="text-white font-bold text-base md:text-lg mb-3">Design jobs careers</h3>

        <p class="text-gray-400 mb-6">
          Empowering your design career, elevating your skills, helping you land
          your dream role
        </p>

        <div class="flex flex-col items-start gap-8">
          <a
            href="/post-job"
            target="_blank"
            rel="noopener noreferrer"
            class="btn-secondary inline-block"
          >
            Post a job
          </a>

          <!-- Theme toggle (moon = dark, sun = light) – below Post a job -->
          <div
            class="inline-flex items-center rounded-md border border-white/20 bg-white/5 p-0.5"
            role="group"
            aria-label="Theme"
          >
            <div class="relative group">
              <button
                type="button"
                (click)="themeService.setDarkTheme(true)"
                class="flex h-7 w-7 items-center justify-center rounded transition-colors"
                [ngClass]="{
                  'bg-white/20': (themeService.isDarkTheme$ | async),
                  'text-white': (themeService.isDarkTheme$ | async),
                  'text-gray-400': !(themeService.isDarkTheme$ | async)
                }"
                aria-label="Dark mode"
              >
                <hugeicons-icon
                  [icon]="icons.moon"
                  [size]="18"
                  color="currentColor"
                  [strokeWidth]="2"
                  class="block"
                  aria-hidden="true"
                />
              </button>
              <div
                class="pointer-events-none absolute bottom-full left-1/2 mb-2 -translate-x-1/2 whitespace-nowrap rounded-lg bg-gray-800 px-2.5 py-1.5 text-xs font-medium text-white opacity-0 shadow-lg transition-opacity duration-200 group-hover:opacity-100"
              >
                Switch to dark mode
                <div
                  class="absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-gray-800"
                  aria-hidden="true"
                ></div>
              </div>
            </div>
            <div class="relative group">
              <button
                type="button"
                (click)="themeService.setDarkTheme(false)"
                class="flex h-7 w-7 items-center justify-center rounded transition-colors"
                [ngClass]="{
                  'bg-white/20': !(themeService.isDarkTheme$ | async),
                  'text-white': !(themeService.isDarkTheme$ | async),
                  'text-gray-400': (themeService.isDarkTheme$ | async)
                }"
                aria-label="Light mode"
              >
                <hugeicons-icon
                  [icon]="icons.sun"
                  [size]="18"
                  color="currentColor"
                  [strokeWidth]="2"
                  class="block"
                  aria-hidden="true"
                />
              </button>
              <div
                class="pointer-events-none absolute bottom-full left-1/2 mb-2 -translate-x-1/2 whitespace-nowrap rounded-lg bg-gray-800 px-2.5 py-1.5 text-xs font-medium text-white opacity-0 shadow-lg transition-opacity duration-200 group-hover:opacity-100"
              >
                Switch to light mode
                <div
                  class="absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-gray-800"
                  aria-hidden="true"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="flex gap-3">
          <a
            href="#"
            aria-label="Follow us on LinkedIn"
            class="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
              />
            </svg>
          </a>
          <a
            href="#"
            aria-label="Follow us on Twitter"
            class="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
              />
            </svg>
          </a>
          <a
            href="#"
            aria-label="Follow us on Instagram"
            class="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.897 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.897-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"
              />
            </svg>
          </a>
        </div> -->
      </div>

      <!-- For Designers -->
      <div class="col-span-2 md:col-span-1">
        <h3 class="text-white mb-3 md:mb-4">For Designers</h3>
        <ul class="space-y-3">
          <li>
            <a
              routerLink="/jobs"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >Browse jobs</a
            >
          </li>
          <li>
            <a
              routerLink="/companies-hiring-this-week"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >Companies hiring this week</a
            >
          </li>
          <li>
            <a
              routerLink="/company"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >All companies</a
            >
          </li>
          <li>
            <a
              routerLink="/jobs/locations"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >Jobs by location</a
            >
          </li>
          <li>
            <a
              routerLink="/ai-job-matcher"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >Job matcher</a
            >
          </li>
          <li>
            <a
              routerLink="/salary-guide"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >Salary guide</a
            >
          </li>
          <li>
            <a
              routerLink="/blog"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >Blog</a
            >
          </li>
          <li>
            <a
              routerLink="/portfolios"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >Top 2026 Portfolios</a
            >
          </li>
        </ul>
      </div>

      <!-- For Employers -->
      <div class="col-span-1 md:col-span-1">
        <h3 class="text-white mb-3 md:mb-4">For Employers</h3>
        <ul class="space-y-3">
          <li>
            <a
              routerLink="/hire-designers"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >Hire designers</a
            >
          </li>
          <li>
            <a
              routerLink="/post-job"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >Post a job</a
            >
          </li>
          <!-- The Pricing link list item is removed here -->
          <!-- <a -->
          <!--  routerLink="/employer-resources" -->
          <!--  class="text-sm text-gray-500 hover:text-sage-dark dark:text-gray-400 dark:hover:text-purple-400 transition-colors" -->
          <!-- > -->
          <!--  Employer Resources -->
          <!-- </a> -->
        </ul>
      </div>

      <!-- Company -->
      <div class="col-span-1 md:col-span-1">
        <h3 class="text-white mb-3 md:mb-4">Company</h3>
        <ul class="space-y-3">
          <li>
            <a
              routerLink="/about"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >About us</a
            >
          </li>
          <li>
            <a
              routerLink="/contact"
              (click)="scrollToTop()"
              class="text-gray-400 hover:text-white transition-colors"
              >Contact</a
            >
          </li>
          <!-- <li> -->
          <!--   <a -->
          <!--     routerLink="/faq" -->
          <!--     (click)="scrollToTop()" -->
          <!--     class="text-gray-400 hover:text-white transition-colors" -->
          <!--     >FAQ</a -->
          <!--   > -->
          <!-- </li> -->
          <li>
            <a
              href="https://buymeacoffee.com/designjobs"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-400 hover:text-white transition-colors"
            >
              Buy me a coffee
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- SEO Section: Job Links -->
    <div class="hidden md:block mt-16 pt-12 border-t border-white/10">
      <div class="grid md:grid-cols-4 gap-8">
        <!-- Design jobs by role -->
        <div>
          <h3 class="text-white mb-3 md:mb-4">Design jobs by role</h3>
          <ul class="space-y-2">
            <li>
              <a
                routerLink="/jobs/product-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Product designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/ui-ux-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >UI/UX designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/ux-research"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >UX researcher jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/graphic-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Graphic designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/design-leadership"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design leadership jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/brand-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Brand designer jobs</a
              >
            </li>
          </ul>
        </div>

        <!-- Design jobs by type -->
        <div>
          <h3 class="text-white mb-3 md:mb-4">Design jobs by type</h3>
          <ul class="space-y-2">
            <li>
              <a
                routerLink="/jobs"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Full-time jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/remote"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Remote jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Contract jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Freelance jobs</a
              >
            </li>
          </ul>
        </div>

        <!-- Remote Design jobs -->
        <div>
          <h3 class="text-white mb-3 md:mb-4">Remote design jobs</h3>
          <ul class="space-y-2">
            <li>
              <a
                routerLink="/jobs/remote"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Remote anywhere</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/remote/united-states"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Remote jobs in the US</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/remote/united-kingdom"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Remote jobs in the UK</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/remote/canada"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Remote jobs in Canada</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/remote"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Remote jobs in Europe</a
              >
            </li>
          </ul>
        </div>

        <!-- Design jobs by location -->
        <div>
          <h3 class="text-white mb-3 md:mb-4">Design jobs by location</h3>
          <ul class="space-y-2">
            <li>
              <a
                routerLink="/jobs/new-york-united-states"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in New York</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/san-francisco-united-states"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in San Francisco</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/london-united-kingdom"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in London</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/bengaluru-india"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in Bengaluru</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/toronto-canada"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in Toronto</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/los-angeles-united-states"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in Los Angeles</a
              >
            </li>
          </ul>
        </div>
      </div>

      <!-- Popular job searches (role + location combinations) -->
      <div class="grid md:grid-cols-4 gap-8 mt-8">
        <div>
          <h3 class="text-white mb-3 md:mb-4">Popular job searches</h3>
          <ul class="space-y-2">
            <li>
              <a
                routerLink="/jobs/product-design/new-york-united-states"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Product designer in New York</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/ui-ux-design/san-francisco-united-states"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >UI/UX designer in San Francisco</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/ux-research/london-united-kingdom"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >UX researcher in London</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/product-design/remote"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Remote product designer</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/design-leadership/united-states"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design lead in the US</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/ui-ux-design/remote"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Remote UI/UX designer</a
              >
            </li>
          </ul>
        </div>

        <div>
          <h3 class="text-white mb-3 md:mb-4">
            Jobs by experience level
          </h3>
          <ul class="space-y-2">
            <li>
              <a
                routerLink="/jobs"
                [queryParams]="{ search: 'junior' }"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Junior designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs"
                [queryParams]="{ search: 'mid-level' }"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Mid-level designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs"
                [queryParams]="{ search: 'senior' }"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Senior designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs"
                [queryParams]="{ search: 'lead' }"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Lead designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs"
                [queryParams]="{ search: 'principal' }"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Principal designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs"
                [queryParams]="{ search: 'entry level' }"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Entry level designer jobs</a
              >
            </li>
          </ul>
        </div>

        <div>
          <h3 class="text-white mb-3 md:mb-4">Top tech hubs</h3>
          <ul class="space-y-2">
            <li>
              <a
                routerLink="/jobs/austin-united-states"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in Austin</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/seattle-united-states"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in Seattle</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/berlin-germany"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in Berlin</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/tel-aviv-israel"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in Tel Aviv</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/singapore-singapore"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in Singapore</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/amsterdam-netherlands"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design jobs in Amsterdam</a
              >
            </li>
          </ul>
        </div>

        <div>
          <h3 class="text-white mb-3 md:mb-4">Browse by specialty</h3>
          <ul class="space-y-2">
            <li>
              <a
                routerLink="/jobs/motion-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Motion designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/web-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Web designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/interaction-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Interaction designer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/design-engineering"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design engineer jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs"
                [queryParams]="{ search: 'design system' }"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design systems jobs</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs"
                [queryParams]="{ search: 'accessibility' }"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Accessibility design jobs</a
              >
            </li>
          </ul>
        </div>
      </div>

      <!-- Additional countries section -->
      <div class="grid md:grid-cols-4 gap-8 mt-8 mb-8">
        <div>
          <h3 class="text-white mb-3 md:mb-4">
            Designer jobs by country
          </h3>
          <ul class="space-y-2">
            <li>
              <a
                routerLink="/jobs/united-states"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Designer jobs in the US</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/india"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Designer jobs in India</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/united-kingdom"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Designer jobs in the UK</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/canada"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Designer jobs in Canada</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/germany"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Designer jobs in Germany</a
              >
            </li>
            <li>
              <a
                routerLink="/jobs/brazil"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Designer jobs in Brazil</a
              >
            </li>
          </ul>
        </div>

        <!-- Top Designer Portfolios 2026 -->
        <div>
          <h3 class="text-white mb-3 md:mb-4">Top portfolios 2026</h3>
          <ul class="space-y-2">
            <li>
              <a
                routerLink="/portfolios/product-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Product design portfolios</a
              >
            </li>
            <li>
              <a
                routerLink="/portfolios/design-leadership"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Design leadership portfolios</a
              >
            </li>
            <li>
              <a
                routerLink="/portfolios/graphic-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Graphic design portfolios</a
              >
            </li>
            <li>
              <a
                routerLink="/portfolios/web-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Web design portfolios</a
              >
            </li>
            <li>
              <a
                routerLink="/portfolios/ux-research"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >UX research portfolios</a
              >
            </li>
            <li>
              <a
                routerLink="/portfolios/motion-design"
                (click)="scrollToTop()"
                class="text-gray-400 hover:text-white transition-colors text-sm"
                >Motion design portfolios</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div
      class="flex flex-col md:flex-row justify-between items-center gap-8 pt-8 border-t border-white/10"
    >
      <!-- Copyright -->
      <div
        class="text-gray-400 flex flex-col items-center md:flex-row md:items-baseline"
      >
        <span>© {{ currentYear }} Designjobs</span
        ><span class="hidden md:inline px-1"> - </span
        ><span>With ❤️ For Designers, By Designers</span>
      </div>
      <!-- Policy Links -->
      <div
        class="flex flex-row items-center gap-4 md:gap-6"
      >
        <a
          routerLink="/privacy"
          (click)="scrollToTop()"
          class="text-gray-400 hover:text-white transition-colors text-[14px] md:text-sm"
          >Privacy Policy</a
        >
        <a
          routerLink="/terms"
          (click)="scrollToTop()"
          class="text-gray-400 hover:text-white transition-colors text-[14px] md:text-sm"
          >Terms of Service</a
        >
        <a
          routerLink="/cookies"
          (click)="scrollToTop()"
          class="text-gray-400 hover:text-white transition-colors text-[14px] md:text-sm"
          >Cookie Policy</a
        >
      </div>
    </div>
  </div>
</footer>
</div>